import { render, staticRenderFns } from "./app-error-notice.vue?vue&type=template&id=06f2bc54"
import script from "./app-error-notice.vue?vue&type=script&lang=js"
export * from "./app-error-notice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports